import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TranscriptTemplate } from "./routes";

export default store => ({
  path: "configure-templates",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-configure-templates" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [TranscriptTemplate(store)],
});
